import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import './PricingPage.css';

const PricingPage = () => {
  const [isYearly, setIsYearly] = useState(false);
  const [openFaq, setOpenFaq] = useState(null);

  const toggleFaq = (index) => {
    setOpenFaq(openFaq === index ? null : index);
  };

  const competitorFeatures = [
    {
      feature: "Randevu Yönetimi",
      randevu345: true,
      competitor1: true,
      competitor2: true,
      competitor3: "Sınırlı"
    },
    {
      feature: "Müşteri Yönetimi",
      randevu345: true,
      competitor1: true,
      competitor2: "Temel",
      competitor3: false
    },
    {
      feature: "Kasa Yönetimi",
      randevu345: true,
      competitor1: "Ek Ücret",
      competitor2: false,
      competitor3: false
    },
    {
      feature: "Personel Yönetimi",
      randevu345: true,
      competitor1: "Ek Ücret",
      competitor2: "Temel",
      competitor3: false
    },
    {
      feature: "Raporlama ve Analiz",
      randevu345: true,
      competitor1: "Temel",
      competitor2: "Temel",
      competitor3: false
    },
    {
      feature: "Online Randevu Sistemi",
      randevu345: true,
      competitor1: "Ek Ücret",
      competitor2: true,
      competitor3: "Sınırlı"
    },
    {
      feature: "SMS Bildirimleri",
      randevu345: true,
      competitor1: "Ek Ücret",
      competitor2: "Ek Ücret",
      competitor3: false
    },
    {
      feature: "Salona Özel Web Sitesi",
      randevu345: true,
      competitor1: false,
      competitor2: false,
      competitor3: false
    },
    {
      feature: "Mobil Uygulama",
      randevu345: true,
      competitor1: "Temel",
      competitor2: false,
      competitor3: false
    },
    {
      feature: "Bulut Yedekleme",
      randevu345: true,
      competitor1: "Ek Ücret",
      competitor2: "Temel",
      competitor3: false
    },
    {
      feature: "7/24 Destek",
      randevu345: true,
      competitor1: "İş Saatleri",
      competitor2: "Email",
      competitor3: false
    },
    {
      feature: "Ücretsiz Güncellemeler",
      randevu345: true,
      competitor1: "Sınırlı",
      competitor2: "Sınırlı",
      competitor3: false
    },
    {
      feature: "Çoklu Şube Desteği",
      randevu345: true,
      competitor1: "Ek Ücret",
      competitor2: false,
      competitor3: false
    },
    {
      feature: "API Entegrasyonu",
      randevu345: true,
      competitor1: false,
      competitor2: false,
      competitor3: false
    }
  ];

  const faqData = [
    {
      question: "Randevu345'i kullanmaya nasıl başlarım?",
      answer: "Çok basit! Mobil uygulamamızı App Store veya Google Play'den indirin, hesabınızı oluşturun ve 30 gün boyunca tüm özellikleri ücretsiz deneyin. Kurulum süreci sadece 5 dakika sürer."
    },
    {
      question: "30 günlük deneme süresi sonunda ne olur?",
      answer: "Deneme süreniz bittiğinde, eğer devam etmek isterseniz aylık veya yıllık abonelik seçeneklerinden birini seçebilirsiniz. İstemezseniz hiçbir ücret ödemeden hesabınızı iptal edebilirsiniz."
    },
    {
      question: "Verilerim güvende mi?",
      answer: "Evet, kesinlikle! Tüm verileriniz 256-bit SSL şifreleme ile korunur ve KVKK uyumlu olarak saklanır. Düzenli yedeklemeler yapılır ve verilerinize sadece siz erişebilirsiniz."
    },
    {
      question: "Kaç personel ve müşteri kaydedebilirim?",
      answer: "Randevu345'te sınırsız personel ve müşteri kaydedebilirsiniz. İster tek kişilik bir salon olun, ister büyük bir zincir işletme, tüm ihtiyaçlarınızı karşılayabiliriz."
    },
    {
      question: "Mobil uygulama ve web versiyonu var mı?",
      answer: "Evet! Hem iOS hem Android için mobil uygulamamız var. Ayrıca web tarayıcısından da sisteme erişebilirsiniz. Tüm cihazlarınızda senkronize çalışır."
    },
    {
      question: "Müşterilerim online randevu alabilir mi?",
      answer: "Tabii ki! Müşterileriniz için özel web sitesi oluşturuyoruz. Buradan 7/24 randevu alabilir, mevcut randevularını görüntüleyebilir ve değiştirebilirler."
    },
    {
      question: "Destek hizmeti nasıl?",
      answer: "7/24 Türkçe destek hizmeti sunuyoruz. Telefon, email, WhatsApp ve canlı chat ile bize ulaşabilirsiniz. Teknik ekibimiz her zaman yardımınıza hazır."
    },
    {
      question: "İptal etmek istersem ne yapmalıyım?",
      answer: "İstediğiniz zaman aboneliğinizi iptal edebilirsiniz. Uygulama içinden veya destek ekibimizle iletişime geçerek iptal işlemini gerçekleştirebilirsiniz. Kalan süreniz boyunca sistemi kullanmaya devam edebilirsiniz."
    },
    {
      question: "Diğer sistemlerden veri aktarımı yapabilir miyim?",
      answer: "Evet! Mevcut sisteminizdeki müşteri ve randevu verilerinizi Randevu345'e aktarmanıza yardımcı oluyoruz. Teknik ekibimiz bu süreci sizin için ücretsiz olarak gerçekleştirir."
    }
  ];

  return (
    <div className="pricing-page-wrapper">
      <Helmet>
        <title>Randevu345 - Şeffaf ve Uygun Fiyatlar | Salon Yönetim Sistemi</title>
        <meta name="description" content="Salon işletmeniz için en uygun paketi seçin. Gizli ücret yok, tüm özellikler dahil. 30 gün ücretsiz deneme, istediğiniz zaman iptal edebilirsiniz." />
        <meta name="keywords" content="randevu345 fiyat, salon yönetimi fiyat, kuaför programı fiyat, berber yazılımı fiyat, salon otomasyonu fiyat" />
        <link rel="canonical" href="https://345.com.tr/pricing" />
        
        {/* Open Graph */}
        <meta property="og:title" content="Randevu345 - Şeffaf ve Uygun Fiyatlar" />
        <meta property="og:description" content="Salon işletmeniz için en uygun paketi seçin. Gizli ücret yok, tüm özellikler dahil. 30 gün ücretsiz deneme." />
        <meta property="og:url" content="https://345.com.tr/pricing" />
        
        {/* Twitter */}
        <meta name="twitter:title" content="Randevu345 - Şeffaf ve Uygun Fiyatlar" />
        <meta name="twitter:description" content="Salon işletmeniz için en uygun paketi seçin. Gizli ücret yok, tüm özellikler dahil. 30 gün ücretsiz deneme." />
      </Helmet>
      {/* Hero Section */}
      <section className="pricing-hero-section">
        <div className="pricing-container">
          <div className="pricing-hero-content">
            <h1 className="pricing-hero-title">
              Şeffaf ve 
              <span className="pricing-gradient-text"> Uygun Fiyatlar</span>
            </h1>
            <p className="pricing-hero-description">
              Salon işletmeniz için en uygun paketi seçin. Gizli ücret yok, 
              tüm özellikler dahil. İstediğiniz zaman iptal edebilirsiniz.
            </p>
            
            {/* Pricing Toggle */}
            <div className="pricing-toggle-wrapper">
              <span className={`pricing-toggle-label ${!isYearly ? 'active' : ''}`}>Aylık</span>
              <div className="pricing-toggle-switch" onClick={() => setIsYearly(!isYearly)}>
                <div className={`pricing-toggle-slider ${isYearly ? 'yearly' : ''}`}></div>
              </div>
              <span className={`pricing-toggle-label ${isYearly ? 'active' : ''}`}>
                Yıllık 
                <span className="pricing-save-badge">2 Ay Bedava</span>
              </span>
            </div>
          </div>
        </div>
      </section>

      {/* Pricing Cards */}
      <section className="pricing-cards-section">
        <div className="pricing-container">
          <div className="pricing-cards-grid">
            {/* Single Plan Card */}
            <div className="pricing-card-wrapper featured">
              <div className="pricing-popular-badge">En Popüler</div>
              <div className="pricing-card-header">
                <h3 className="pricing-card-title">Randevu345 Pro</h3>
                <p className="pricing-card-subtitle">Tüm özellikler dahil</p>
                <div className="pricing-card-price">
                  <span className="pricing-currency">₺</span>
                  <span className="pricing-amount">{isYearly ? '733' : '800'}</span>
                  <span className="pricing-period">/ay</span>
                </div>
                {isYearly && (
                  <div className="pricing-yearly-info">
                    <span className="pricing-yearly-total">Yıllık ₺8.800 (2 ay bedava)</span>
                    <span className="pricing-monthly-equivalent">Aylık ₺800 yerine ₺733</span>
                  </div>
                )}
              </div>
              
              <div className="pricing-card-features">
                <div className="pricing-feature-item">
                  <span className="pricing-feature-check">✓</span>
                  <span>Sınırsız randevu yönetimi</span>
                </div>
                <div className="pricing-feature-item">
                  <span className="pricing-feature-check">✓</span>
                  <span>Sınırsız müşteri kaydı</span>
                </div>
                <div className="pricing-feature-item">
                  <span className="pricing-feature-check">✓</span>
                  <span>Personel yönetimi</span>
                </div>
                <div className="pricing-feature-item">
                  <span className="pricing-feature-check">✓</span>
                  <span>Kasa ve muhasebe</span>
                </div>
                <div className="pricing-feature-item">
                  <span className="pricing-feature-check">✓</span>
                  <span>Online randevu sistemi</span>
                </div>
                <div className="pricing-feature-item">
                  <span className="pricing-feature-check">✓</span>
                  <span>SMS bildirimleri</span>
                </div>
                <div className="pricing-feature-item">
                  <span className="pricing-feature-check">✓</span>
                  <span>Salona özel web sitesi</span>
                </div>
                <div className="pricing-feature-item">
                  <span className="pricing-feature-check">✓</span>
                  <span>Detaylı raporlama</span>
                </div>
                <div className="pricing-feature-item">
                  <span className="pricing-feature-check">✓</span>
                  <span>7/24 destek</span>
                </div>
                <div className="pricing-feature-item">
                  <span className="pricing-feature-check">✓</span>
                  <span>Ücretsiz güncellemeler</span>
                </div>
              </div>
              
              <div className="pricing-card-cta">
                <button className="pricing-cta-button primary">
                  30 Gün Ücretsiz Deneyin
                </button>
                <p className="pricing-cta-note">Kredi kartı bilgisi gerektirmez</p>
              </div>
            </div>
          </div>
          
          {/* Trust Indicators */}
          <div className="pricing-trust-section">
            <div className="pricing-trust-item">
              <span className="pricing-trust-icon">🔒</span>
              <span className="pricing-trust-text">256-bit SSL Güvenlik</span>
            </div>
            <div className="pricing-trust-item">
              <span className="pricing-trust-icon">💳</span>
              <span className="pricing-trust-text">Güvenli Ödeme</span>
            </div>
            <div className="pricing-trust-item">
              <span className="pricing-trust-icon">📞</span>
              <span className="pricing-trust-text">7/24 Destek</span>
            </div>
            <div className="pricing-trust-item">
              <span className="pricing-trust-icon">✨</span>
              <span className="pricing-trust-text">30 Gün Para İade Garantisi</span>
            </div>
          </div>
        </div>
      </section>

      {/* Comparison Table */}
      <section className="pricing-comparison-section">
        <div className="pricing-container">
          <div className="pricing-comparison-header">
            <h2 className="pricing-comparison-title">
              Rakiplerle <span className="pricing-gradient-text">Detaylı Karşılaştırma</span>
            </h2>
            <p className="pricing-comparison-subtitle">
              Randevu345'in neden en iyi seçim olduğunu görün
            </p>
          </div>
          
          <div className="pricing-comparison-table-wrapper">
            <table className="pricing-comparison-table">
              <thead>
                <tr>
                  <th className="pricing-feature-column">Özellikler</th>
                  <th className="pricing-randevu345-column">
                    <div className="pricing-table-header">
                      <img src="/assets/logo-color.svg" alt="Randevu345" className="pricing-table-logo" />
                      
                      <div className="pricing-table-price">₺{isYearly ? '733' : '800'}/ay</div>
                    </div>
                  </th>
                  <th className="pricing-competitor-column">
                    <div className="pricing-table-header">
                      <span>Rakip A</span>
                      <div className="pricing-table-price">₺950/ay</div>
                    </div>
                  </th>
                  <th className="pricing-competitor-column">
                    <div className="pricing-table-header">
                      <span>Rakip B</span>
                      <div className="pricing-table-price">₺750/ay</div>
                    </div>
                  </th>
                  <th className="pricing-competitor-column">
                    <div className="pricing-table-header">
                      <span>Rakip C</span>
                      <div className="pricing-table-price">₺600/ay</div>
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                {competitorFeatures.map((item, index) => (
                  <tr key={index} className="pricing-table-row">
                    <td className="pricing-feature-name">{item.feature}</td>
                    <td className="pricing-randevu345-cell">
                      {item.randevu345 === true ? (
                        <span className="pricing-check-icon">✓</span>
                      ) : item.randevu345 === false ? (
                        <span className="pricing-cross-icon">✗</span>
                      ) : (
                        <span className="pricing-limited-text">{item.randevu345}</span>
                      )}
                    </td>
                    <td className="pricing-competitor-cell">
                      {item.competitor1 === true ? (
                        <span className="pricing-check-icon">✓</span>
                      ) : item.competitor1 === false ? (
                        <span className="pricing-cross-icon">✗</span>
                      ) : (
                        <span className="pricing-limited-text">{item.competitor1}</span>
                      )}
                    </td>
                    <td className="pricing-competitor-cell">
                      {item.competitor2 === true ? (
                        <span className="pricing-check-icon">✓</span>
                      ) : item.competitor2 === false ? (
                        <span className="pricing-cross-icon">✗</span>
                      ) : (
                        <span className="pricing-limited-text">{item.competitor2}</span>
                      )}
                    </td>
                    <td className="pricing-competitor-cell">
                      {item.competitor3 === true ? (
                        <span className="pricing-check-icon">✓</span>
                      ) : item.competitor3 === false ? (
                        <span className="pricing-cross-icon">✗</span>
                      ) : (
                        <span className="pricing-limited-text">{item.competitor3}</span>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </section>

      {/* Final CTA */}
      <section className="pricing-final-cta-section">
        <div className="pricing-container">
          <div className="pricing-final-cta-content">
            <h2 className="pricing-final-cta-title">
              Hemen Başlayın, <span className="pricing-gradient-text">Farkı Yaşayın</span>
            </h2>
            <p className="pricing-final-cta-description">
              Binlerce salon işletmecisinin tercihi Randevu345. 
              Siz de katılın ve işinizi bir üst seviyeye taşıyın.
            </p>
            <div className="pricing-final-cta-buttons">
              <a 
                href="https://play.google.com/store/apps/details?id=com.randevu345.app" 
                className="pricing-final-cta-button primary"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src="/assets/googleplay.svg" alt="Google Play'den İndirin" />
              </a>
              <a 
                href="https://apps.apple.com/tr/app/randevu345/id6743093049" 
                className="pricing-final-cta-button primary"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src="/assets/appstore.svg" alt="App Store'dan İndirin" />
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="pricing-faq-section">
        <div className="pricing-container">
          <div className="pricing-faq-header">
            <h2 className="pricing-faq-title">
              Sıkça <span className="pricing-gradient-text">Sorulan Sorular</span>
            </h2>
            <p className="pricing-faq-subtitle">
              Merak ettiğiniz her şeyin cevabı burada. Başka sorularınız varsa 7/24 destek ekibimizle iletişime geçin.
            </p>
          </div>
          
          <div className="pricing-faq-list">
            {faqData.map((faq, index) => (
              <div key={index} className={`pricing-faq-item ${openFaq === index ? 'active' : ''}`}>
                <div 
                  className="pricing-faq-question"
                  onClick={() => toggleFaq(index)}
                >
                  <h3>{faq.question}</h3>
                  <span className="pricing-faq-icon">
                    {openFaq === index ? '−' : '+'}
                  </span>
                </div>
                <div className="pricing-faq-answer">
                  <p>{faq.answer}</p>
                </div>
              </div>
            ))}
          </div>
          
          <div className="pricing-faq-contact">
            <p className="pricing-faq-contact-text">
              Sorunuzun cevabını bulamadınız mı? 
              <span className="pricing-phone-number">0850 307 0 <span className="pricing-phone-highlight">345</span></span>
            </p>
            <a href="#contact" className="pricing-faq-contact-button">
              Bize Ulaşın
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PricingPage; 